const selfSelector = (state) => state.auth

export default selfSelector
